import { createFormState, required } from "redux-freeform";
import { TURNSTILE } from "../../constants/data_constants";

const formState = {
  captchaToken: {
    validators: [required()]
  },
  // The captcha provider is used to determine which captcha service to use
  captchaProvider: {
    defaultValue: "TURNSTILE"
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formState
);
